export default "__VITE_ASSET__f0015912__"